// MODÜL 8: GRUP MÜLAKATI SİMÜLASYONU - ZENGİN İÇERİK

const cabinCrewContentsM8Extra = {
  // ==================== ÜNİTE 3: GRUP DİNAMİKLERİ ====================
  'CM-M8-U3-L1': {
    lesson_id: 'CM-M8-U3-L1',
    title: 'Grup Rolleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup Çalışmasında Roller',
      paragraphs: [
        'LİDER: Yönlendiren, organize eden. Dikkat: Baskın lider özelliği KÖTÜ!',
        'KOLAYLAŞTIRICI: Sessiz olanları dahil eden, uzlaştıran. EN İYİ ROL!',
        'FİKİR ÜRETİCİ: Yaratıcı öneriler sunan. Değerli ama dinlemeyi de unutma.',
        'ANALİZCİ: Değerlendiren, eleştiren. Yapıcı ol, yıkıcı değil.',
        'UYGULAYICI: Pratik çözümler sunan, somutlaştıran.',
        'ÖNEMLİ: Tek role takılma. Duruma göre rol değiştir.'
      ],
      keyPoints: [
        'Kolaylaştırıcı en değerli',
        'Baskın lider olma',
        'Rolleri değiştir',
        'Herkesi dahil et'
      ]
    }
  },
  'CM-M8-U3-L2': {
    lesson_id: 'CM-M8-U3-L2',
    title: 'Sessiz Adayları Dahil Etme',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Sessiz Kalan Adayları Nasıl Dahil Edersin?',
      paragraphs: [
        'Neden önemli: Kolaylaştırıcı rolü gösterir. Değerlendirmeciler bunu sever.',
        'Nasıl: "Sence nasıl olmalı, [isim]?" diye sor.',
        'Dikkat: Başkalarının sözünü kesme. Sıra gelince nazikçe dahil et.',
        'Örnek: "Henüz herkesin fikrini almadık. Belki Ahmet de bir şey eklemek ister?"',
        'Sonuç: Hem sessiz adaya yardım edersin, hem de sen öne çıkarsın.'
      ],
      keyPoints: [
        'İsimle hitap et',
        'Sözü kesme, sıra bekle',
        'Nazikçe davet et',
        'Kolaylaştırıcı ol'
      ]
    }
  },
  'CM-M8-U3-L3': {
    lesson_id: 'CM-M8-U3-L3',
    title: 'Baskın Adaylarla Başa Çıkma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Baskın Aday Varsa Ne Yapmalı?',
      paragraphs: [
        'Baskın aday: Sürekli konuşan, başkalarını kesen, her şeyi kontrol etmeye çalışan.',
        'YAPMA: Kavga etme, küsüp sessiz kalma, pasif agresif olma.',
        'YAP: Nazikçe ara gir. "Güzel fikir, bir de şöyle düşünebilir miyiz..."',
        'YAP: Grupla konuş. "Herkesin fikrini alalım mı?"',
        'Değerlendirmeci: Baskın adayı da izliyor. Onlar genellikle düşük puan alır.'
      ],
      keyPoints: [
        'Kavga etme',
        'Nazikçe ara gir',
        'Gruba yönlendir',
        'Baskın = Düşük puan'
      ]
    }
  },
  'CM-M8-U3-L4': {
    lesson_id: 'CM-M8-U3-L4',
    title: 'Senaryo: Baskın Aday',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Bir aday tüm tartışmayı domine ediyor, başkaları konuşamıyor. Ne yaparsınız?',
      context: 'Grup aktivitesi: Havayolu için maskot seçimi. 6 kişi, 15 dakika.',
      options: [
        { id: 'A', text: '"Lütfen sus, başkaları da konuşsun!" derim', isCorrect: false },
        { id: 'B', text: 'Sessiz kalıp beklerim, nasılsa değerlendirmeci görüyor', isCorrect: false },
        { id: 'C', text: '"Güzel fikirler, herkesin önerisini de duyabilir miyiz?" derim', isCorrect: true },
        { id: 'D', text: 'Ben de aynı şekilde baskın olurum', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Nazik müdahale + grupla yönlendirme = Kolaylaştırıcı liderlik.',
        wrong: 'Hatalı. A agresif, B pasif, D rekabetçi. C dengeli ve profesyonel.'
      },
      explanation: 'Baskın adayla başa çıkma: 1) Sabırlı ol, 2) Fikrini onayla, 3) Gruba yönlendir, 4) Dahil et.'
    }
  },
  'CM-M8-U3-L5': {
    lesson_id: 'CM-M8-U3-L5',
    title: '🎮 Grup Rolleri Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { id: 1, left: 'Kolaylaştırıcı', right: 'Sessizleri dahil eden' },
        { id: 2, left: 'Baskın Lider', right: 'Genellikle düşük puan' },
        { id: 3, left: 'Fikir Üreticisi', right: 'Yaratıcı öneriler' },
        { id: 4, left: 'Analizci', right: 'Değerlendiren, eleştiren' },
        { id: 5, left: 'Uygulayyıcı', right: 'Pratik çözümler' }
      ]
    }
  },

  // ==================== ÜNİTE 4: ANLAŞMAZLIK YÖNETİMİ ====================
  'CM-M8-U4-L1': {
    lesson_id: 'CM-M8-U4-L1',
    title: 'Fikir Ayrılığı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Farklı Fikirler Olduğunda',
      paragraphs: [
        'Normal: Grup çalışmasında fikir ayrılığı NORMAL. Hatta beklenir.',
        'Değerlendirme: Sizin fikriniz değil, NASIL tartıştığınız değerleniyor.',
        'YAPMA: "Sen yanlışsın", "Bu fikir kötü", "Bence saçma" deme.',
        'YAP: "Farklı bir açıdan bakarsak...", "Buna ek olarak..." de.',
        'Uzlaşma: Her zaman ortayı bul. "Her iki fikri de birleştirebilir miyiz?"'
      ],
      keyPoints: [
        'Fikir ayrılığı normal',
        'Nasıl tartıştığın önemli',
        '"Sen yanlışsın" deme',
        'Uzlaşmayı ara'
      ]
    }
  },
  'CM-M8-U4-L2': {
    lesson_id: 'CM-M8-U4-L2',
    title: 'Uzlaşma Teknikleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Uzlaşma Nasıl Sağlanır?',
      paragraphs: [
        'Teknik 1 - ORTAK NOKTA: "Her iki fikirde de [X] ortak. Buradan başlayalım."',
        'Teknik 2 - BİRLEŞTİRME: "Ahmet\'in fikri + Ayşe\'nin fikri = Yeni çözüm"',
        'Teknik 3 - ÖNCELİK: "Zaman kısıtlı, en önemli 2 şeye odaklanalım."',
        'Teknik 4 - OYLAMA: "Herkes el kaldırsın, hangi fikir daha çok destek alıyor?"',
        'Not: Sen karar verme, grup karar versin. Sen sadece süreci kolaylaştır.'
      ],
      keyPoints: [
        'Ortak nokta bul',
        'Fikirleri birleştir',
        'Önceliklendirme öner',
        'Grup karar versin'
      ]
    }
  },
  'CM-M8-U4-L3': {
    lesson_id: 'CM-M8-U4-L3',
    title: 'Senaryo: Anlaşmazlık',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'İki aday farklı fikirler konusunda ısrar ediyor, zaman doluyor. Ne yaparsınız?',
      context: 'Logo seçimi: Birisi "kırmızı" diyor, diğeri "mavi". 3 dakika kaldı.',
      options: [
        { id: 'A', text: 'Birine "sen haklısın" deyip taraf tutarrım', isCorrect: false },
        { id: 'B', text: '"Her ikisini de içeren bir tasarım öneriyorum" derim', isCorrect: true },
        { id: 'C', text: 'Sessiz kalıp karar vermelerini beklerim', isCorrect: false },
        { id: 'D', text: '"Zaman yetti, bu kadar" deyip aktiviteyi bitiririm', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Birleştirici çözüm = Her iki fikre de saygı + sonuç odaklılık.',
        wrong: 'Hatalı. A taraf tutar, C pasif, D pes eder. B uzlaştırıcı.'
      },
      explanation: 'Anlaşmazlık yönetimi: 1) Taraf tutma, 2) Her iki fikri de onayla, 3) Birleştirici çözüm öner.'
    }
  },
  'CM-M8-U4-L4': {
    lesson_id: 'CM-M8-U4-L4',
    title: '⚡ Uzlaşma Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Fikir ayrılığında taraf tutmalı mı?', options: ['Evet', 'Hayır', 'Bazen', 'Her zaman'], correct: 1 },
        { q: 'En iyi uzlaşma tekniği?', options: ['Kavga', 'Sessizlik', 'Birleştirme', 'Ayrılma'], correct: 2 },
        { q: '"Sen yanlışsın" demek yerine ne denmeli?', options: ['Sama', 'Farklı bakış açısı', 'Kötü fikir', 'Suspend'], correct: 1 },
        { q: 'Grupta kim karar vermeli?', options: ['Sen', 'Lider', 'Grup birlikte', 'Değerlendirmeci'], correct: 2 },
        { q: 'Anlaşmazlık normal mi?', options: ['Evet', 'Hayır', 'Kötü', 'Felaket'], correct: 0 }
      ]
    }
  },

  // ==================== ÜNİTE 5: SÖZLÜ İLETİŞİM ====================
  'CM-M8-U5-L1': {
    lesson_id: 'CM-M8-U5-L1',
    title: 'Etkili Konuşma',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup İçinde Etkili Konuşma',
      paragraphs: [
        'Kısa ve öz: Uzun monologlardan kaçın. 20-30 saniye ideal.',
        'Net ol: "Belki şöyle olabilir herhalde" yerine "Bence şu önemli çünkü..."',
        'Sıra bekle: Başkaları bitmeden araya girme.',
        'Göz teması: Sadece değerlendirmeciye değil, tüm gruba bak.',
        'Ses tonu: Monoton değil, vurgulu. Önemli kelimeleri vurgula.'
      ],
      keyPoints: [
        '20-30 saniye ideal',
        'Net ve somut ol',
        'Sıra bekle',
        'Tüm gruba bak'
      ]
    }
  },
  'CM-M8-U5-L2': {
    lesson_id: 'CM-M8-U5-L2',
    title: 'Aktif Dinleme',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Grup İçinde Aktif Dinleme',
      paragraphs: [
        'Baş onayı: Konuşan kişiye başınla "anlıyorum" işareti ver.',
        'Göz teması: Konuşan kişiye bak, etrafa bakma.',
        'Not al: Kısa notlar. "Ahmet: logo fkri" gibi.',
        'Referans ver: "Ahmet\'in dediği gibi..." diye başla. Dinlediğini göster.',
        'Soru sor: "Bunu biraz açar mısın?" İlgiyi gösterir.'
      ],
      keyPoints: [
        'Baş onayı ver',
        'Konuşana bak',
        'Kısa not al',
        'Referans ver'
      ]
    }
  },
  'CM-M8-U5-L3': {
    lesson_id: 'CM-M8-U5-L3',
    title: 'Fikir Sunumu',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Fikrinizi Nasıl Sunarsınız?',
      paragraphs: [
        'Yapı: Önce fikir, sonra neden. "[Fikir], çünkü [sebep]."',
        'Örnek: "Yeşil renk öneriyorum, çünkü çevre dostu imaj veriyor."',
        'Bağlantı: Önceki fikirlere bağla. "Ayşe\'nin önerisine ek olarak..."',
        'Açık ol: "Ne dersiniz?" diye sor. Geri bildirime açık ol.',
        'Vazgeçebilirlik: Daha iyi fikir çıkarsa, kendi fikrinden vazgeçmeyi bil.'
      ],
      keyPoints: [
        'Fikir + Sebep',
        'Önceki fikirlere bağla',
        'Geri bildirime açık ol',
        'Vazgeçmeyi bil'
      ]
    }
  },
  'CM-M8-U5-L4': {
    lesson_id: 'CM-M8-U5-L4',
    title: 'Senaryo: Fikir Sunumu',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Sıra size geldi, fikrinizi nasıl sunarsınız?',
      context: 'Havayolu slogani belirleme. "Widen Your World" gibi bir slogan arıyorsunuz.',
      options: [
        { id: 'A', text: '"Bilmiyorum, siz karar verin."', isCorrect: false },
        { id: 'B', text: '"Fly with Trust öneriyorum, çünkü güven mesajı veriyor. Siz ne düşünürsünüz?"', isCorrect: true },
        { id: 'C', text: '"En iyi slogan benim fikrim, kesinlikle bu olmalı!"', isCorrect: false },
        { id: 'D', text: '3 dakika boyunca detaylı sunum yaparım', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Fikir + Sebep + Geri bildirime açıklık = İdeal sunum.',
        wrong: 'Hatalı. A pasif, C kibirli, D çok uzun. B dengeli ve profesyonel.'
      },
      explanation: 'Fikir sunumu: 1) Kısa ve net fikir, 2) Kısa sebep, 3) Gruba sor.'
    }
  },
  'CM-M8-U5-L5': {
    lesson_id: 'CM-M8-U5-L5',
    title: '🎮 Boşluk Doldur: İletişim',
    type: 'fillin',
    duration: 4,
    xp: 35,
    fillin: {
      sentences: [
        { text: 'Etkili konuşma süresi: 20-30 ___', answer: 'saniye' },
        { text: 'Dinlediğini göstermek için: ___ onayı ver', answer: 'baş' },
        { text: '"Ahmet\'in dediği gibi..." = ___ verme', answer: 'referans' },
        { text: 'Fikir sunduktan sonra: "Ne ___?" sor', answer: 'dersiniz' },
        { text: 'Daha iyi fikir çıkarsa: Kendi fikrinden ___', answer: 'vazgeç' }
      ]
    }
  },

  // ==================== ÜNİTE 6: AKTİVİTE TİPLERİ ====================
  'CM-M8-U6-L1': {
    lesson_id: 'CM-M8-U6-L1',
    title: 'Sorun Çözme Aktivitesi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Problem Solving Activity',
      paragraphs: [
        'Örnek: "Uçakta bebek ağlıyor, yolcu şikayet ediyor. Ne yaparsınız?"',
        'Yaklaşım: 1) Sorunu tanımla, 2) Seçenekleri listele, 3) En iyisini seç, 4) Uygula.',
        'Dikkat: Tek doğru cevap yok. SÜRECİ değerlendiriyorlar.',
        'Önemli: Ekip çalışması göster. Herkesin fikrini al.',
        'Sonuç: "Kararımız [X]. Çünkü [Y]." diye özetle.'
      ],
      keyPoints: [
        'Sorunu tanımla',
        'Seçenekleri listele',
        'Süreç önemli',
        'Birlikte karar ver'
      ]
    }
  },
  'CM-M8-U6-L2': {
    lesson_id: 'CM-M8-U6-L2',
    title: 'Yaratıcılık Aktivitesi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Creativity Activity',
      paragraphs: [
        'Örnek: "Havayolu için maskot tasarımı", "Yeni kabinler servis fikri"',
        'Beyin fırtınası: Elejtirmeden tüm fikirleri listele. "Kötü fikir yok" kuralı.',
        'Birleştirme: Farklı fikirlerin en iyi yönlerini birleştir.',
        'Sunum: Kreatif ama profesyonel. Aşırı komik/çılgın olma.',
        'İşbirliği: Herkesin katkısını vurgula. "Biz birlikte [X] tasarladık."'
      ],
      keyPoints: [
        'Beyin fırtınası yap',
        'Kötü fikir yok',
        'Fikirleri birleştir',
        '"Biz" vurgusu'
      ]
    }
  },
  'CM-M8-U6-L3': {
    lesson_id: 'CM-M8-U6-L3',
    title: 'Tartışma Aktivitesi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Discussion Activity',
      paragraphs: [
        'Örnek: "Kabin memuru için en önemli 3 özellik nedir?"',
        'Yaklaşım: Fikrini söyle + sebep ver + başkalarını dinle.',
        'Dikkat: Agresif tartışmadan kaçın. "Saygıyla katılmıyorum" de.',
        'Uzlaşma: Ortak noktaları bul. "Hepimiz [X]\'in önemli olduğunda hem fikir."',
        'Sonuç: Grup kararını özetle. "Grubumuz [X, Y, Z] seçti."'
      ],
      keyPoints: [
        'Fikir + sebep',
        'Agresif olma',
        'Ortak nokta bul',
        'Grup kararını özetle'
      ]
    }
  },
  'CM-M8-U6-L4': {
    lesson_id: 'CM-M8-U6-L4',
    title: 'Senaryo: Yaratıcılık',
    type: 'scenario',
    duration: 10,
    xp: 50,
    scenario: {
      question: 'Grup "havayolu için yeni maskot" tasarlıyor. Birisi "ejderha" diyor, başkası "kuş". En iyi yaklaşım?',
      context: 'Değerlendirmeciler yaratıcılık ve işbirliğini izliyor.',
      options: [
        { id: 'A', text: '"Ejderha iyi fikir değil" deyip sadece kuşu desteklerim', isCorrect: false },
        { id: 'B', text: '"Kangatlı bir kuş olsun, ejderha gibi güçlü" öneririm', isCorrect: true },
        { id: 'C', text: 'Kendi fikrim olan "aslan"\'u ısrarla savunurum', isCorrect: false },
        { id: 'D', text: 'Sessiz kalıp onların karar vermesini beklerim', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Birleştirici çözüm = Yaratıcılık + İşbirliği. Değerlendirmeciler bunu sever!',
        wrong: 'Hatalı. A eleştirel, C bencil, D pasif. B hem yaratcı hem birleştirici.'
      },
      explanation: 'Yaratıcılık aktivitesinde: 1) Fikirleri eleştirme, 2) Birleştirici ol, 3) "Biz" de.'
    }
  },
  'CM-M8-U6-L5': {
    lesson_id: 'CM-M8-U6-L5',
    title: '⚡ Aktivite Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 50,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Problem solving ilk adımı?', options: ['Çözüm', 'Sorunu tanımla', 'Oylama', 'Sunum'], correct: 1 },
        { q: 'Beyin fırtınasında "kötü fikir" var mı?', options: ['Evet', 'Hayır', 'Bazen', 'Çok'], correct: 1 },
        { q: 'Tartışmada ne dememeli?', options: ['Katılıyorum', 'Güzel fikir', 'Sen yanlışsın', 'Ekleyebilir miyim'], correct: 2 },
        { q: 'Grup kararını kim özetler?', options: ['Lider', 'Gönüllü', 'Değerlendirmeci', 'Kimse'], correct: 1 },
        { q: 'Aktivite sonunda ne vurguların?', options: ['Ben yaptım', 'Biz yaptık', 'Onlar yaptı', 'Olmadı'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 7: FİNAL SİMÜLASYON ====================
  'CM-M8-U7-L1': {
    lesson_id: 'CM-M8-U7-L1',
    title: 'Tam Simülasyon 1',
    type: 'scenario',
    duration: 15,
    xp: 60,
    scenario: {
      question: 'Aktivite: "Yeni bir havayolu kuruyorsunuz. Adını, sloganını ve ilk 3 rotaını belirleyin." Grup 2 dakika sessiz, ne yaparsınız?',
      context: '6 kişilik grup, 10 dakika, değerlendirmeciler izliyor.',
      options: [
        { id: 'A', text: 'Beklerim, birisi başlatır', isCorrect: false },
        { id: 'B', text: '"Herkes önce kendi fikrini söylesin, sonra birleştirelim" derim', isCorrect: true },
        { id: 'C', text: 'Tüm kararları kendim veririm', isCorrect: false },
        { id: 'D', text: 'Değerlendirmeciye "nasıl başlayalım?" diye sorarım', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Başlatıcı müdahale + yapı önerisi + herkesi dahil etme = İdeal.',
        wrong: 'Hatalı. A pasif, C baskın, D dışarı danışma (zayıf görünür).'
      },
      explanation: 'Sessizlik olduğunda: 1) Yapı öner, 2) Herkesi dahil et, 3) Başlat ama domine etme.'
    }
  },
  'CM-M8-U7-L2': {
    lesson_id: 'CM-M8-U7-L2',
    title: 'Tam Simülasyon 2',
    type: 'scenario',
    duration: 15,
    xp: 60,
    scenario: {
      question: 'Aktivite sonunda sunum yapacaksınız. Kim sunum yapmalı?',
      context: 'Grubunuz başarılı bir çalışma yaptı, sonuç hazır.',
      options: [
        { id: 'A', text: 'En çok konuşan kişi', isCorrect: false },
        { id: 'B', text: 'Gönüllü olan veya grubun seçtiği kişi', isCorrect: true },
        { id: 'C', text: 'Herkes aynı anda', isCorrect: false },
        { id: 'D', text: 'Hiç sunum yapmayın', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Gönüllük veya grup kararı = Demokratik yaklaşım.',
        wrong: 'Hatalı. Sunum önemli. Gönüllü veya grup seçsin.'
      },
      explanation: 'Sunum: 1) Gönüllü olabilirsin (artı), 2) Grup seçsin, 3) "Biz" vurgusu, 4) Herkesin katkısını belirt.'
    }
  },
  'CM-M8-U7-L3': {
    lesson_id: 'CM-M8-U7-L3',
    title: 'Tam Simülasyon 3',
    type: 'scenario',
    duration: 15,
    xp: 60,
    scenario: {
      question: 'Aktivite ortasında bir aday ağlamaya başladı. Ne yaparsınız?',
      context: 'Stres altında duygusal tepki. Değerlendirmeciler izliyor.',
      options: [
        { id: 'A', text: 'Görmezden gelip aktiviteye devam ederim', isCorrect: false },
        { id: 'B', text: 'Nazikçe "Bir şey içer misin, iyi misin?" derim', isCorrect: true },
        { id: 'C', text: '"Kendine hakim ol" derim', isCorrect: false },
        { id: 'D', text: 'Değerlendirmeciye şikayet ederim', isCorrect: false }
      ],
      feedback: {
        correct: 'Harika! Empati + yardım teklifi = Kabin ekibi ruhunu gösteriyorsun.',
        wrong: 'Hatalı. A ilgisiz, C sert, D şikayet. B empatik ve yardımsever.'
      },
      explanation: 'Duygusal durumda: 1) Empati göster, 2) Yardım teklif et, 3) Mahcup etme, 4) Aktiviteyi nazikçe sürdür.'
    }
  },
  'CM-M8-U7-L4': {
    lesson_id: 'CM-M8-U7-L4',
    title: 'Grup Mülakatı Final Quiz',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Grup mülakatında en değerli rol?', options: ['Baskın lider', 'Kolaylaştırıcı', 'Sessiz gözlemci', 'Eleştirmen'], correct: 1 },
        { q: 'Sessiz adayı nasıl dahil edersin?', options: ['İsmiyle sor', 'Görmezden gel', 'Şikayet et', 'Yerine konuş'], correct: 0 },
        { q: 'Fikir ayrılığında ne yapmalı?', options: ['Taraf tut', 'Kavga et', 'Uzlaştır', 'Sus'], correct: 2 },
        { q: 'Etkili konuşma süresi?', options: ['2 dakika', '20-30 saniye', '5 dakika', '10 saniye'], correct: 1 },
        { q: 'Beyin fırtınasında kötü fikir var mı?', options: ['Evet', 'Hayır', 'Çok var', 'Bazen'], correct: 1 },
        { q: 'Sunum sonunda ne vurguların?', options: ['Ben', 'Biz', 'Onlar', 'Kimse'], correct: 1 },
        { q: 'Baskın adaya ne yapmalı?', options: ['Aynı davran', 'Nazikçe gruba yönlendir', 'Kavga et', 'Şikayet et'], correct: 1 },
        { q: 'Aktivite sessizlikle başlarsa?', options: ['Bekle', 'Yapı öner', 'Değerlendirmeciye sor', 'Git'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM8Extra;
